/**
 * 旧設計（英語スラッグ）の役職コード互換レイヤ。
 *
 * @deprecated 英語スラッグの役職コード（representative_director 等）はファントムコードで、
 * 実データ（member_role_masters）に存在しない。役職の正本は member_role_masters.code
 * （3桁数値文字列 "001"〜"008"）。後方互換のラベル/カラー変換のみ残置する。
 * 新規コードは数値コード（001-008）または lib/auth/roles.ts の認証ロールを使うこと。
 */

/** @deprecated 英語スラッグ役職コード → 日本語ラベル（後方互換のみ） */
export const LEGACY_ROLE_MASTER_LABELS: Record<string, string> = {
  representative_director: '代表取締役',
  executive: '役員',
  division_head: '事業部長',
  division_head_sub: '事業部長サブ',
  division_vice_head: '事業副部長',
  department_head: '部長',
  section_chief: '課長',
  leader: 'リーダー',
  staff: 'スタッフ',
}

/** @deprecated 英語スラッグ役職コード → カラー（後方互換のみ・数値コードは level 駆動に移行） */
export const LEGACY_ROLE_MASTER_COLORS: Record<string, { bg: string; text: string }> = {
  representative_director: { bg: 'bg-red-200', text: 'text-red-800' },
  executive: { bg: 'bg-red-100', text: 'text-red-700' },
  division_head: { bg: 'bg-amber-100', text: 'text-amber-800' },
  division_head_sub: { bg: 'bg-amber-100', text: 'text-amber-700' },
  division_vice_head: { bg: 'bg-amber-100', text: 'text-amber-700' },
  department_head: { bg: 'bg-amber-100', text: 'text-amber-700' },
  section_chief: { bg: 'bg-yellow-100', text: 'text-yellow-700' },
  leader: { bg: 'bg-green-100', text: 'text-green-700' },
  staff: { bg: 'bg-muted', text: 'text-label' },
}
